import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Tab, Tabs } from '../../components/Tabs/Tabs';
import { deductionActions } from '../../redux/actions/deductionActions';
import CreateTab from './CreateTab';
import DetailTab from './DetailTab';
import MainTab from './MainTab';

const DeductionPage = () => {
  const dispatch = useDispatch();
  const { activeTabKey, tabs } = useSelector(state => state.deduction);

  return (
    <div>
      <Tabs
        activeKey={activeTabKey}
        onClick={key => dispatch(deductionActions.changeTab(key))}
      >
        <Tab title="List">
          <MainTab />
        </Tab>
        <Tab title="Buat">
          <CreateTab />
        </Tab>
        {tabs.map((row, key) =>
          <Tab
            key={row.key}
            title={row.title}
            isLoading={row.loading}
            onClose={() => dispatch(deductionActions.closeTab(row.key))}
            onClick={() => dispatch(deductionActions.changeTab(row.key))}
            active={activeTabKey === row.key}
          >
            <DetailTab index={key} />
          </Tab>
        )}
      </Tabs>
    </div>
  )
}

export default DeductionPage
